<!--
	Body of one Interventions legend section; `pairedSystemId` mirrors each toggle onto a second
	layer's first item (Visibility keeps SSD and SSDObstructions in step).
-->
<script lang="ts">
	import DataNotAvailable from '#lib/components/DataNotAvailable.svelte';
	import LegendItems from '../../legends/LegendItems.svelte';
	import { legendStore } from '#lib/stores/legendStore.svelte.js';
	import { geodataStore } from '#lib/stores/geodataStore.svelte.js';
	import { mapExtentStore } from '#lib/stores/mapExtentStore.svelte.js';
	import { ESafeCurvesModule, type ISafeCurvesSystemLayers } from '../interfaces';
	import { disableByZoom } from '../../legendHelpers';

	interface Props {
		systemId: string;
		pairedSystemId?: string;
	}

	const { systemId, pairedSystemId }: Props = $props();

	const systemData = $derived(geodataStore.systemData as ISafeCurvesSystemLayers);
	const available = $derived(
		systemData[ESafeCurvesModule.Interventions]?.[systemId as never] != null
	);

	const legend = $derived(legendStore.layers.find((l) => l.systemId === systemId));
	const pairedLegend = $derived(
		pairedSystemId ? legendStore.layers.find((l) => l.systemId === pairedSystemId) : undefined
	);

	const mapZoom = $derived(mapExtentStore.zoom);

	function toggleItem(legendItemId: string, enabled: boolean) {
		if (!legend) return;
		legendStore.setLegendLayerVisibility({ layerId: legend.layerId, legendItemId, enabled });
		if (pairedLegend) {
			legendStore.setLegendLayerVisibility({
				layerId: pairedLegend.layerId,
				legendItemId: pairedLegend.legendItems[0].legendItemId,
				enabled
			});
		}
	}
</script>

{#if !available || !legend || (pairedSystemId && !pairedLegend)}
	<DataNotAvailable />
{:else}
	<LegendItems
		{legend}
		patch="square"
		disabled={disableByZoom(legend.minzoom, mapZoom)}
		selectAll={legend.legendItems.length > 1}
		ontoggle={toggleItem} />
{/if}
